import ReviewStars from "./ReviewStars.component";

export default ReviewStars;
